import { useEffect, useState, useCallback } from 'react';
import { BehaviorSubject } from 'rxjs';

export const TOKEN = 'token';
export const SNACKBAR = 'snack';
export const INPUT_FOCUS = 'input-focus';
export const NOTIFICATIONS = 'notifications';
export const MINIMIZED_MENU = 'minimized-menu';
export const SEARCH = 'search';
export const MEETING_ASIDE_OPEN = 'meeting-aside-open';
export const DIALOG = 'dialog';
export const APP_ASIDE = 'app-aside';
export const GPT_MESSAGE = 'klang-gpt-message';
export const GUEST = 'klang-is-guest';
export const TRANSCRIPT_OPTIONS = 'transcript-options';

const TOKEN_IDENTIFIER = 'l2s-token';
const USER_IDENTIFIER = 'l2s-user';

export const store = {
  [TOKEN]: new BehaviorSubject(localStorage.getItem(TOKEN_IDENTIFIER)),
  [SNACKBAR]: new BehaviorSubject([]),
  [INPUT_FOCUS]: new BehaviorSubject(false),
  [NOTIFICATIONS]: new BehaviorSubject(
    JSON.parse(sessionStorage.getItem(NOTIFICATIONS))
  ),
  [MINIMIZED_MENU]: new BehaviorSubject(localStorage.getItem(MINIMIZED_MENU)),
  [SEARCH]: new BehaviorSubject(''),
  [MEETING_ASIDE_OPEN]: new BehaviorSubject(false),
  [DIALOG]: new BehaviorSubject(null),
  [APP_ASIDE]: new BehaviorSubject({ folderCollapses: {} }),
  [GPT_MESSAGE]: new BehaviorSubject(localStorage.getItem(GPT_MESSAGE)),
  [GUEST]: new BehaviorSubject(!!localStorage.getItem(GUEST)),
  [TRANSCRIPT_OPTIONS]: new BehaviorSubject(
    JSON.parse(localStorage.getItem(TRANSCRIPT_OPTIONS) || '{}')
  ),
};

store[TOKEN].subscribe((value) => {
  if (!value) {
    localStorage.removeItem(TOKEN_IDENTIFIER);
  } else {
    localStorage.setItem(TOKEN_IDENTIFIER, value);
  }
});

store[GUEST].subscribe((value) => {
  if (!value) {
    localStorage.removeItem(GUEST);
  } else {
    localStorage.setItem(GUEST, value);
  }
});

store[NOTIFICATIONS].subscribe((value) => {
  if (!value) {
    sessionStorage.removeItem(NOTIFICATIONS);
  } else {
    sessionStorage.setItem(NOTIFICATIONS, JSON.stringify(value));
  }
});

store[MINIMIZED_MENU].subscribe((value) => {
  if (!value) {
    localStorage.removeItem(MINIMIZED_MENU);
  } else {
    localStorage.setItem(MINIMIZED_MENU, value);
  }
});

store[GPT_MESSAGE].subscribe((value) => {
  if (!value) {
    localStorage.removeItem(GPT_MESSAGE);
  } else {
    localStorage.setItem(GPT_MESSAGE, value);
  }
});

store[TRANSCRIPT_OPTIONS].subscribe((value) => {
  if (!value) {
    localStorage.removeItem(TRANSCRIPT_OPTIONS);
  } else {
    localStorage.setItem(TRANSCRIPT_OPTIONS, JSON.stringify(value));
  }
});

export function useStore(key) {
  if (!store[key]) {
    throw Error(`No such store key: ${key}`);
  }

  const [value, setValue] = useState(store[key].value);

  const updateValue = useCallback(
    (newValue) => {
      store[key].next(newValue);
    },
    [key]
  );

  useEffect(() => {
    const subscription = store[key].subscribe(setValue);
    return () => subscription.unsubscribe();
  }, [key]);

  return [value, updateValue];
}

export function getValue(key) {
  return store[key].value;
}

export function addSnack(msg) {
  store[SNACKBAR].next([msg]);
}

export function setDialog(dialog) {
  store[DIALOG].next(dialog);
}

export function removeUser() {
  localStorage.removeItem(USER_IDENTIFIER);
}

export function storeSettingsForTranscript(transcriptId, options) {
  const curr = store[TRANSCRIPT_OPTIONS].value || {};
  if (Object.keys(curr) > 10 && !transcriptId in curr) {
    // Delete the oldest one
    delete curr[Object.keys(curr)[0]];
  }

  store[TRANSCRIPT_OPTIONS].next({
    ...curr,
    [transcriptId]: options,
  });
}

window.addEventListener('storage', (e) => {
  // solves issue where token is updated in another tab
  // and we need to update the token in the current tab
  // without a refresh
  if (e.key === TOKEN_IDENTIFIER) {
    store[TOKEN].next(e.newValue);
  }
});
